import { makeStyles } from "@mui/styles";
import { getRGBA } from "utils/color";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 16px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: `${getRGBA("#3024E1", 0.04)}`,
    },
  },
  orgAndStatusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    alignItems: "flex-start",
  },

  eSocialContainerConnected: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${getRGBA("#2E7D32", 0.1)}`,
    color: "#2E7D32",
    padding: "3px 10px",
    borderRadius: "100px",
  },

  eSocialContainerPending: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${getRGBA("#EF6C00", 0.08)}`,
    padding: "3px 10px",
    borderRadius: "100px",
  },
  buttonBase: {
    width: "100%",
    textAlign: "left",
  },

  eSocialConnected: {
    fontFamily: "Nunito",
    lineHeight: "18px",
    fontSize: "13px",
    fontWeight: "400",
    color: "#2E7D32",
  },

  eSocialPending: {
    fontFamily: "Nunito",
    lineHeight: "18px",
    fontSize: "13px",
    fontWeight: "400",
    color: "#EF6C00",
  },

  organization: {
    fontFamily: "Sora",
    lineHeight: "19px",
    fontSize: "14px",
    fontWeight: "700",
    color: "#3F4947",
  },

  federalTaxId: {
    fontFamily: "Nunito",
    lineHeight: "20px",
    fontSize: "12px",
    fontWeight: "400",
    color: "#3F4947",
  },

  orgTypeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "3px 10px",
    borderRadius: "100px",
  },

  orgType: {
    fontFamily: "Nunito",
    lineHeight: "18px",
    fontSize: "13px",
    fontWeight: "600",
  },
}));

export { useStyles };
